// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2_WtI","header":"MessagesList_header__22nRg","chat":"MessagesList_chat__ZUH7k"};